import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  signal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RadioState } from '@app/core/states/radio.state';
import { Playlist } from '@app/library/models/playlist.model';
import { AddToPlaylistRequest } from '@app/library/states/playlists.actions';
import { PlaylistsState } from '@app/library/states/playlists.state';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Select } from '@ngxs/store';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'rk-mob-add-to-playlist-modal',
  templateUrl: './mob-add-to-playlist-modal.component.html',
  styleUrls: ['./mob-add-to-playlist-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobAddToPlaylistModalComponent implements OnInit {
  @Select(RadioState.currentRadioId)
  currentRadioId$: Observable<number>;

  @Select(PlaylistsState.playlists)
  allPlaylists$: Observable<Playlist[]>;

  playlists: Playlist[];

  searchSubject = new BehaviorSubject<string>('');

  $touched = signal(-1);

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly dialogRef: MatDialogRef<MobAddToPlaylistModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dataIn: { trackId: number },
  ) {}

  ngOnInit(): void {
    combineLatest([this.allPlaylists$, this.searchSubject.asObservable()])
      .pipe(filter(([p]) => !!p))
      .subscribe(([allPlaylists, val]) => {
        this.playlists = allPlaylists.filter(
          playlist => playlist.name.toLowerCase().indexOf(val.trim().toLowerCase()) > -1,
        );
        this.cdr.detectChanges();
      });
  }

  @Dispatch()
  clickPlaylist(id: number) {
    return new AddToPlaylistRequest(id, [this.dataIn.trackId]);
  }

  onTouch(index: number) {
    setTimeout(() => {
      this.$touched.set(index);
    }, 50);
  }

  onTouchEnd() {
    this.$touched.set(-1);
  }

  search(e: string) {
    if (typeof e === 'string') {
      this.searchSubject.next(e);
    }
  }

  exitPanel() {
    this.dialogRef.close();
  }
}
